import { PickType } from '@nestjs/swagger';
import { BoardPurchaseFloorCascadableInterface } from '../interfaces/board-purchase-floor-cascadable.interface';
import { BoardPurchaseFloorDto } from './board-purchase-floor.dto';

export class BoardPurchaseFloorCascadeDto
  extends PickType(BoardPurchaseFloorDto, ['boardTypeId', 'floor', 'quantity'])
  implements BoardPurchaseFloorCascadableInterface {}
